<template>
  <div class="section-container">
    <p class="section-title" :class="computedFontTitle">
      {{ title }}
    </p>
    <div v-if="subtitle" class="text-h-4 section-subtitle">
      {{ subtitle }}
    </div>
    <slot />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Section extends Vue {
  @Prop({ type: String, required: true })
  private title!: string;

  @Prop({ type: String, required: false })
  private subtitle?: string;

  @Prop({ type: String, default: '3' })
  private size!: string;

  private get computedFontTitle() {
    return `text-h-${this.size}`;
  }
}
</script>

<style lang="less" scoped>
.section {
  &-container {
    margin-bottom: @size-spacing-x800;
  }
  &-title {
    color: @text-primary;
  }
  &-subtitle {
    margin-bottom: @size-spacing-x400;
    color: @text-secondary;
  }
}
</style>
